var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('layout-simple', [_c('v-card', {
    staticClass: "mx-auto",
    attrs: {
      "max-width": "375"
    }
  }, [_c('v-img', {
    attrs: {
      "src": require("@/assets/undraw_female_avatar_w3jk.svg"),
      "alt": _vm.user.lastName,
      "height": "300px",
      "dark": ""
    },
    on: {
      "click": _vm.uploadAvatar
    }
  }, [_c('v-row', {
    staticClass: "fill-height"
  }, [_c('v-spacer'), _c('v-card-title', {
    staticClass: "white--text pl-12 pt-12"
  }, [_c('div', {
    staticClass: "display-1 pl-12 pt-12"
  }, [_vm._v(_vm._s(_vm.user.name))])])], 1)], 1), _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item', [_c('v-list-item-icon', [_c('v-icon', [_vm._v("mdi-account")])], 1), _c('v-list-item-content', [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "label": "Username",
      "disabled": ""
    },
    model: {
      value: _vm.user.userName,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "userName", $$v);
      },
      expression: "user.userName"
    }
  }), _c('v-text-field', {
    attrs: {
      "outlined": "",
      "label": "Vorname"
    },
    model: {
      value: _vm.user.firstName,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "firstName", $$v);
      },
      expression: "user.firstName"
    }
  }), _c('v-text-field', {
    attrs: {
      "outlined": "",
      "label": "Nachname"
    },
    model: {
      value: _vm.user.lastName,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "lastName", $$v);
      },
      expression: "user.lastName"
    }
  })], 1)], 1), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _c('v-list-item', [_c('v-list-item-icon', [_c('v-icon', [_vm._v("mdi-phone")])], 1), _c('v-list-item-content', [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "label": "Telefon"
    },
    model: {
      value: _vm.contact.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.contact, "phone", $$v);
      },
      expression: "contact.phone"
    }
  })], 1)], 1), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _c('v-list-item', [_c('v-list-item-icon', [_c('v-icon', [_vm._v("mdi-email")])], 1), _c('v-list-item-content', [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "label": "Email"
    },
    model: {
      value: _vm.contact.email,
      callback: function callback($$v) {
        _vm.$set(_vm.contact, "email", $$v);
      },
      expression: "contact.email"
    }
  })], 1)], 1), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _c('v-list-item', [_c('v-list-item-icon', [_c('v-icon', [_vm._v("mdi-map-marker")])], 1), _c('v-list-item-content', [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "label": "Straße und Hausnummer"
    },
    model: {
      value: _vm.address.street,
      callback: function callback($$v) {
        _vm.$set(_vm.address, "street", $$v);
      },
      expression: "address.street"
    }
  }), _c('v-text-field', {
    attrs: {
      "outlined": "",
      "label": "Stadt"
    },
    model: {
      value: _vm.address.city,
      callback: function callback($$v) {
        _vm.$set(_vm.address, "city", $$v);
      },
      expression: "address.city"
    }
  }), _c('v-text-field', {
    attrs: {
      "outlined": "",
      "label": "ZIP"
    },
    model: {
      value: _vm.address.zip,
      callback: function callback($$v) {
        _vm.$set(_vm.address, "zip", $$v);
      },
      expression: "address.zip"
    }
  }), _c('v-text-field', {
    attrs: {
      "outlined": "",
      "label": "Bundesland"
    },
    model: {
      value: _vm.address.state,
      callback: function callback($$v) {
        _vm.$set(_vm.address, "state", $$v);
      },
      expression: "address.state"
    }
  })], 1)], 1)], 1), _c('v-card-actions', [_c('v-btn', {
    staticClass: "ml-5 pb-2 pt-2",
    attrs: {
      "text": "",
      "icon": ""
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(" Save "), _c('v-icon', [_vm._v("mdi-content-save")])], 1), _c('v-spacer')], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }